import normalize from 'json-api-normalizer';
import Task from './task.js';
import SurveyLink from './survey_link.js';

export default class Stage {
	static from (jsonapi) {
		let key = 'stages'
		let normalizedJSONapi = normalize(jsonapi);
		if (!(Object.keys(normalizedJSONapi).includes(key))) return null;

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = Stage.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return Stage.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi, noRelationships=0) {
		const { id, attributes } = jsonapi;

		let relationships = {}
		if (jsonapi.relationships && noRelationships == 0) {
			if (jsonapi.relationships['tasks']) {
				relationships['tasks'] = {}
				jsonapi.relationships['tasks'].data.forEach( function (rel) {
					relationships['tasks'][rel.id] = Task.make(normalizedJSONapi[rel.type][rel.id], normalizedJSONapi);
				});
			}

			if (jsonapi.relationships['surveyLinks']) {
				relationships['surveyLinks'] = {}
				jsonapi.relationships['surveyLinks'].data.forEach( function (rel) {
					relationships['surveyLinks'][rel.id] = SurveyLink.make(normalizedJSONapi[rel.type][rel.id], normalizedJSONapi);
				});
			}
		}

		return new Stage( Object.assign({id: id}, attributes, relationships) );
	}

	constructor ({ id, name, position, programId, createdAt, updatedAt, tasks, contentLinks, surveyLinks, version, completion, unlocked }) {
		this.id                 = id ? id : -1;
		this.name               = name ? name : '';
		this.position           = position ? position : 0;
		this.program_id         = programId ? programId : -1;
		this.created_at         = createdAt ? createdAt : null;
		this.updated_at         = updatedAt ? updatedAt : null;
		this.tasks              = tasks ? tasks : {};
		this.contentLinks       = contentLinks ? contentLinks : {};
		this.surveyLinks        = surveyLinks ? surveyLinks : {};
		this.version            = version ? version : 0;
		this.completion         = completion ? completion : 0;
		this.unlocked           = unlocked ? unlocked : false;
	}

	toJSONapi () {
		let attributes = Object.assign({}, this);
		delete attributes.id;

		return {data: {type: "stages", id: this.id, attributes: attributes}};
	}
}
